import Vue from 'vue'
import Router from 'vue-router'
import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/components/containers/DefaultContainer')
const ViewStaffDashboard = () => import('./staff/dashboard')
const ViewStaffSales = () => import('./staff/sales')
const ViewStaffCurrentsAccounts = () => import('./staff/currentsAccounts')
const ViewStaffSettings = () => import('./staff/settings')
const ViewStaffSalesTrashed = () => import('./staff/salesTrashed')
const ViewStaffSalesQuick = () => import('./staff/salesQuick')
const ViewStaffSalesCounter = () => import('./staff/salesCounter')
const ViewStaffReports = () => import('./staff/reports')

Vue.use(Router)

// reference (access.view_reference / m_modules_permissions.reference) ->
// nombre de ruta. Fuente única, ver router/viewsRegistry.js.
const VIEWS = {
  dashboard: 'SalesStaffDashboard',
  sales: 'SalesStaffSales',
  currentsAccounts: 'SalesStaffCurrentsAccounts',
  settings: 'SalesStaffSettings',
  salesTrashed: 'SalesStaffSalesTrashed',
  salesQuick: 'SalesStaffSalesQuick',
  salesCounter: 'SalesStaffSalesCounter',
  reports: 'SalesStaffReports',
}

const router =
  [
    {
      path: '/st/sales',
      component: DefaultContainer,
      children: [
        {
          path: '',
          name: VIEWS.dashboard,
          component: ViewStaffDashboard,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Ventas',
          }            
        },
        {
          path: 'sales',
          name: VIEWS.sales,
          component: ViewStaffSales,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Gestión de ventas',
          }                      
        },
        {
          path: 'sales/generate/remits/:remitsID',
          name: 'SalesStaffSalesGenerateByRemits',
          component: ViewStaffSales,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Ventas desde remitos',
          }                      
        },     
        {
          path: 'sales/generate/orders/:ordersID',
          name: 'SalesStaffSalesGenerateByOrders',
          component: ViewStaffSales,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Ventas desde pedidos',
          }                                
        },                  
        {
          path: 'sales/generate/budget/:budgetID',
          name: 'SalesStaffSalesGenerateByBudget',
          component: ViewStaffSales,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Ventas desde presupuestos',
          }                                
        },         
        {
          path: 'sales/generate/budgets',
          name: 'SalesStaffSalesGenerateByMultipleBudgets',
          component: ViewStaffSales,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Ventas desde múltiples presupuestos',
          }
        },         
        {
          path: 'sales/generate/serviceCustomer/:serviceCustomerID',
          name: 'SalesStaffSalesGenerateByServiceCustomer',
          component: ViewStaffSales,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Ventas desde servicios',
          }                                
        },                   
        {
          path: 'sales/generate/projects/:projectsID',
          name: 'SalesStaffSalesGenerateByProjects',
          component: ViewStaffSales,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Ventas desde proyectos',
          }                                
        },                                 
        {
          path: 'CurrentsAccounts',
          name: VIEWS.currentsAccounts,
          component: ViewStaffCurrentsAccounts,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Cuenta corriente de clientes',
          }                                
        },                
        {
          path: 'settings',
          name: VIEWS.settings,
          component: ViewStaffSettings,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Configuraciones de ventas',
          }                                
        },      
        {
          path: 'salesTrashed',
          name: VIEWS.salesTrashed,
          component: ViewStaffSalesTrashed,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Gestión de ventas sin aprobación',
          }                                
        },    
        {
          path: 'salesQuick',
          name: VIEWS.salesQuick,
          component: ViewStaffSalesQuick,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Venta mostrador',
          }
        },
        {
          path: 'salesCounter',
          name: VIEWS.salesCounter,
          component: ViewStaffSalesCounter,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Venta mostrador',
          }
        },
        {
          path: 'reports',
          name: VIEWS.reports,
          component: ViewStaffReports,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Reporte de ventas',
          }                                
        },              
      ]
    },

    {
      path: '/cu/sales',
      component: DefaultContainer,
      children: [

      ]
    },

    {
      path: '/su/sales',
      component: DefaultContainer,
      children: [

      ]
    },
  ]

export default router
export { VIEWS }
